import universal from 'react-universal-component';
import universalImport from 'babel-plugin-universal-import/universalImport';
import path from 'path';

/* istanbul ignore next */
export default universal(
    universalImport({
        chunkName: () => 'PLCCSlidePanelLazy',
        path: () => path.join(__dirname, './PLCCSlidePanelWrapper'),
        resolve: () => require.resolveWeak('./PLCCSlidePanelWrapper'),
        load: () =>
            Promise.all([
                import(/* webpackChunkName: "PLCCSlidePanelLazy" */ './PLCCSlidePanelWrapper'),
            ]).then((proms) => proms[0]),
    }),
    {
        loading: () => null,
    }
);
